import { TemplateEnum } from "../../types/templateEnum";
import BarChartWithToggleVertical from "./barChartNoPaddingVertical";
import { ChartQuestionAnswersResponseType } from "../../types/chartQuestionAnswersInfoType";
import { NPSDataState } from "../../types/npsTypes";
import BarChartWithToggleHorizontal from "./barChartWithToggleHorizontal";
import React from "react";

type ChartComponentProps = {
  readonly allData: ChartQuestionAnswersResponseType;
  readonly language?: string | undefined;
  readonly NPSData?: Array<NPSDataState>;
};

type ChartMappingType = {
  [key in TemplateEnum]?: React.FC<ChartComponentProps>;
};

export const chartsMapping: ChartMappingType = {
  MULTIPLE_CHOICE: BarChartWithToggleHorizontal,
  SINGLE_CHOICE: BarChartWithToggleHorizontal,
  LOYALTY_INDEX: BarChartWithToggleVertical,
  NPS: BarChartWithToggleVertical,
};
